import { StaticLayout } from './static-layout'

export function CookiesPage() {
  return (
    <StaticLayout title="Cookie policy" description="Last updated: 2026-05-13">
      <h2>What we use</h2>
      <ul>
        <li>
          <strong>Session cookie</strong> — set by our backend after you sign in. httpOnly,
          SameSite=Lax, scoped to the mkdn.app parent domain. Required for authentication; cannot
          be disabled without breaking login.
        </li>
        <li>
          <strong>CSRF cookie (XSRF-TOKEN)</strong> — readable by the SPA so that state-changing
          requests can include a matching <code>X-XSRF-TOKEN</code> header. Required for any write
          operation.
        </li>
        <li>
          <strong>Theme preference</strong> — a small value in <code>localStorage</code> (not a
          cookie) that remembers light/dark/system preference.
        </li>
        <li>
          <strong>Editor preferences</strong> — per-document split/edit/preview view mode stored
          in <code>localStorage</code>.
        </li>
      </ul>
      <h2>Third-party cookies</h2>
      <p>
        We do not embed third-party advertising or analytics cookies inside the editor. If
        Google Analytics is enabled for the marketing pages, it is loaded only after consent
        where required by law.
      </p>
    </StaticLayout>
  )
}
